import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { createGroup } from '@spectee/graphql/mutations';

const document = gql(createGroup);

export function useCreateGroup() {
  return useMutation(document);
}
